export const eAnimationNames = {
  EAN_ANTISIPATOR: 'animation',
  EAN_POPUP_SHINE: 'pop_up_shine',
  EAN_COIN_FLIP: 'coin_flip',
};

export const eBigWinAnimationNames = {
  START: 'bigwin_start',
  IDLE: 'bigwin_loop',
};

export const eMegaWinAnimationNames = {
  START: 'megawin_start',
  IDLE: 'megawin_loop'
};

export const eEpicWinAnimationNames = {
  START: 'epicwin_start',
  IDLE: 'epicwin_loop'
};

export const eJackpotWinAnimationNames = {
  IDLE: 'jackpot'
};

export const eFireAnimationNames = {
  IDLE: 'FireLoop',
  START: 'FireStart'
};


